// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import { ClickTracker } from '@ta/common.tracking';
import ResponsiveAttachedOverlay from '@ta/overlays.responsive-attached-overlay';
import * as Import from '@ta/platform.import';
import { LoadingSpinner } from '@ta/styleguide.loading';
import PickerPreview from './PickerPreview';
import CurrencyPreviewContents from './CurrencyPreviewContents';
import typeof CurrencyOverlayContentComponentType from './CurrencyOverlayContents';
import type { CurrencyPreview } from './types';

import styles from './CurrencyPicker.css';

const [loadCurrencyOverlayContents, CurrencyOverlayContents] = Import.component.onTrigger<
  _,
  React.ElementConfig<CurrencyOverlayContentComponentType>,
>(
  () => import('./CurrencyOverlayContents'),
  'default',
  <div className={styles.loaderWrap}>
    <LoadingSpinner />
  </div>,
);

type ExternalProps = {|
  currencyPreview: CurrencyPreview,
|};

type Props = {|
  ...ExternalProps,
  currentLocale: string,
  srcServlet: string,
|};

const CurrencyPicker = ({ currencyPreview, currentLocale, srcServlet }: Props) => (
  <ResponsiveAttachedOverlay
    position="above"
    alignEdge="right"
    contents={() => <CurrencyOverlayContents />}
  >
    {(target, open, close, isOpened) => (
      <div
        ref={target}
        onClick={() => {
          loadCurrencyOverlayContents();
          open();
        }}
      >
        <ClickTracker
          module="CURRENCY_PICKER"
          action="Open"
          context={currentLocale}
          srcServlet={srcServlet}
        >
          <PickerPreview opened={isOpened}>
            <CurrencyPreviewContents preview={currencyPreview} />
          </PickerPreview>
        </ClickTracker>
      </div>
    )}
  </ResponsiveAttachedOverlay>
);

export default connect<Props, ExternalProps, _, _, _, _>(state => ({
  currentLocale: state.i18n.locale,
  srcServlet: state.tracking.analytics ? state.tracking.analytics.url : '',
}))(CurrencyPicker);
